module.exports = __webpack_public_path__ + "img/icon_csv.d3f3d3d8.svg";